module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-xs-12 scrollable-menu wrapper-box",
    on: {
      "click": function($event) {
        _vm.hasTooltip()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 remove-margins"
  }, [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Added as Favorite\n      "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Shows how many different users added you as their favorite."
    }
  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.FavoriteTimes))])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Repeated stays\n      "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Increases each time a previous client books your services again, this will increase your search ranking."
    }
  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.RepeatedStays))])]), _vm._v(" "), (_vm.performanceComp.AverageResponseTime) ? _c('p', {
    staticClass: "small",
    class: {
      'text-danger': _vm.longAvgResponseComp
    }
  }, [_c('strong', [_vm._v("Avg Response Time")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
    }
  }), _vm._v(":"), _c('strong', [_vm._v(" " + _vm._s(_vm.performanceComp.AverageResponseTime))])]) : _vm._e(), _vm._v(" "), (!_vm.performanceComp.AverageResponseTime) ? _c('p', {
    staticClass: "text-success small"
  }, [_c('strong', [_vm._v("Avg Response Time ")]), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
    }
  }), _vm._v(":"), _c('strong', [_vm._v(" no requests yet.")])]) : _vm._e(), _vm._v(" "), (_vm.performanceComp.ResponseRate != 0) ? _c('p', {
    staticClass: "small",
    class: {
      'text-danger': _vm.responseRateComp
    }
  }, [_c('strong', [_vm._v("Response Rate ")]), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "The percentage of booking requests you received and didn't respond to within 3 days."
    }
  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.ResponseRate) + "%")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Avg Rating\n      "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Average rating stars out of 5 that has been submitted by how many people."
    }
  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.ratingComp))])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Profile Views\n      "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Increases each time someone visits or views your public profile."
    }
  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.ProfileViews))])]), _vm._v(" "), (_vm.currentStatusComp) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Profile Completeness\n      "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "This is an automated system that measures your profile for missing items, required items will show in red while optional items are shown in green."
    }
  }), _vm._v(":"), _c('strong', [_vm._v(" " + _vm._s(_vm.currentStatusComp))])]) : _vm._e(), _vm._v(" "), (_vm.profileMissingInfoComp) ? _c('div', [_c('hr', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), (_vm.profileMissingInfoComp.length > 0) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Profile Pending Items\n        "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "12px",
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Each missing item here can be added by following the link in the description."
    }
  }), _vm._v(":\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profileMissingInfoComp), function(item) {
    return _c('div', [(item.IsRequired) ? _c('p', {
      staticClass: "text-danger small"
    }, [_vm._v("\n          " + _vm._s(item.MissingDesc) + "\n          "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.routerGo(item.MissingLink)
        }
      }
    }, [_vm._v(_vm._s(item.MissingLinkDesc))])]) : _c('p', {
      staticClass: "text-success"
    }, [_vm._v("\n          " + _vm._s(item.MissingDesc) + "\n          "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.routerGo(item.MissingLink)
        }
      }
    }, [_vm._v(_vm._s(item.MissingLinkDesc))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.performanceComp.IsStayPreferenceSet == false) ? _c('button', {
    staticClass: "hidden-md hidden-lg btn btn-block btn-info",
    on: {
      "click": function($event) {
        _vm.goBookingPreference()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" New (Booking Preference)\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "hidden-md hidden-lg btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.goCalendar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Update Calendar\n    ")]), _vm._v(" "), _c('div', [(_vm.performanceComp.IsStayPreferenceSet == false) ? _c('button', {
    staticClass: "hidden-sm hidden-xs btn btn-lg btn-info",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goBookingPreference()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" New (Booking Preference)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false && _vm.singaporeComp == false) ? _c('button', {
    staticClass: "btn btn-lg btn-premium hidden-sm hidden-xs",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("\n        Go Premium "), _c('i', {
    staticClass: "fa fa-paw"
  })]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false && _vm.singaporeComp == false) ? _c('button', {
    staticClass: "btn btn-lg btn-premium btn-block hidden-lg hidden-md",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("\n        Go Premium "), _c('i', {
    staticClass: "fa fa-paw"
  })]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('h4', [_vm._v("Share your profile with friends and family")]), _vm._v(" "), _c('div', {
    staticClass: "center-block",
    staticStyle: {
      "margin-left": "-4px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.shareFacebook()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-3x social",
    attrs: {
      "id": "social-fb"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_top",
      "href": _vm.twitterUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-3x social",
    attrs: {
      "id": "social-tw"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": !_vm.performanceComp.IsProfileReady,
      "target": "_top",
      "href": _vm.linkedinUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-3x social",
    attrs: {
      "id": "social-ln"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": !_vm.performanceComp.IsProfileReady,
      "target": "_top",
      "href": _vm.googleUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus fa-3x social",
    attrs: {
      "id": "social-gp"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": !_vm.performanceComp.IsProfileReady,
      "href": _vm.whatsappUrl,
      "data-action": "share/whatsapp/share"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp fa-3x social",
    attrs: {
      "id": "social-wa"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f82eaff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/FeedbackAndPerformance.vue
// module id = 608
// module chunks = 2